import { render, staticRenderFns } from "./Crisis_talk.vue?vue&type=template&id=c280ed9e"
import script from "./Crisis_talk.vue?vue&type=script&lang=js"
export * from "./Crisis_talk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports